import gaugeType from '../../Utils/gauageUtils'
import { StockPeer } from '../types'
import TwoColGrid from './TwoColGrid'
import { getLastUpdatedTime } from '@/revamp/pods/common/utils/get-last-update'
import { RUPEE_SYMBOL } from '@/root/constants'

const KeyStatsV2 = ({
  stats,
  company_name,
  technical_trend,
  ta_path,
  fundamental_data,
  industry_pe_ratio,
  last_updated,
}: {
  stats?: StockPeer
  company_name?: string
  technical_trend?: string
  ta_path?: string
  fundamental_data?: {
    book_value?: number
    qtr_growth_yoy?: number
  }
  industry_pe_ratio?: number
  last_updated?: string
}) => {
  return (
    <TwoColGrid
      heading={`${company_name} Fundamentals`}
      subheading={
        last_updated
          ? `as on ${getLastUpdatedTime(last_updated)} IST`
          : `Check ${company_name} market cap, PE, PB, PEG ratios, dividend yield, and other key fundamental indicators.`
      }
      keyValueData={[
        {
          key: 'Market Cap',
          value: `${RUPEE_SYMBOL}${stats?.market_cap_value ?? ''} Cr`,
        },
        { key: 'Return on Equity (ROE)', value: stats?.roe ?? '' },
        { key: 'PE Ratio (TTM)', value: stats?.pe_ratio ?? '' },
        { key: 'Return on capital employed (ROCE)', value: stats?.roce ?? '' },
        { key: 'Industry PE ratio', value: industry_pe_ratio ?? '' },
        { key: 'Beta (LTM)', value: stats?.beta ?? '' },
        { key: 'P/B Ratio', value: stats?.pb_ratio ?? '' },
        { key: 'Dividend Yield', value: stats?.dividend_yield ?? '' },
        { key: 'PEG Ratio', value: stats?.peg_ratio ?? '' },
        {
          key: 'Quarterly Earnings Growth YOY',
          value: fundamental_data?.qtr_growth_yoy ?? '',
        },
        { key: 'EPS (TTM)', value: stats?.eps ?? '' },
        { key: 'Sector', value: stats?.sector ?? '' },
        { key: 'Book Value', value: fundamental_data?.book_value ?? '' },
        {
          key: 'Technical Analysis',
          value: gaugeType({
            type: technical_trend,
          }).typeTxt,
          link: 'View Technical Analysis',
          relative_path: ta_path ?? '',
        },
      ]}
    />
  )
}

export default KeyStatsV2
